var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showHeaderContent)?_c('header-block',{attrs:{"theme":_vm.theme}}):_vm._e(),(_vm.showHeaderContent)?_c('main',{staticClass:"main-content",class:{'padding__reset':_vm.isHomePage}},[_c('ErrorNotification'),_c('div',{staticClass:"app-content"},[_c('router-view')],1)],1):[_c('router-view')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }